"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webTypesList = exports.eResourceType = void 0;
/**
 *
 *
 * @export
 * @enum {string}
 */
var eResourceType;
(function (eResourceType) {
    eResourceType["FILE"] = "fil";
    eResourceType["IMAGE_FILE"] = "img";
    eResourceType["PDF_FILE"] = "pdf";
    eResourceType["VIDEO_FILE"] = "vid";
    eResourceType["WEB_LINK"] = "web";
    eResourceType["ARTICLE"] = "article";
    eResourceType["YOUTUBE"] = "yt";
    eResourceType["VIMEO"] = "vim";
    eResourceType["TED_VIDEO"] = "ted";
    eResourceType["UNKNOWN_WEB_VIDEO"] = "webvid";
    eResourceType["WIKIPEDIA"] = "wiki";
    eResourceType["other"] = "web";
})(eResourceType = exports.eResourceType || (exports.eResourceType = {}));
exports.webTypesList = [
    eResourceType.WEB_LINK,
    eResourceType.ARTICLE,
    eResourceType.YOUTUBE,
    eResourceType.VIMEO,
    eResourceType.TED_VIDEO,
    eResourceType.UNKNOWN_WEB_VIDEO,
    eResourceType.WIKIPEDIA
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVzb3VyY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHVibGljL2ludGVyZmFjZXMvUmVzb3VyY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBdUhBOzs7OztHQUtHO0FBQ0gsSUFBWSxhQWFYO0FBYkQsV0FBWSxhQUFhO0lBQ3JCLDZCQUFZLENBQUE7SUFDWixtQ0FBa0IsQ0FBQTtJQUNsQixpQ0FBZ0IsQ0FBQTtJQUNoQixtQ0FBa0IsQ0FBQTtJQUNsQixpQ0FBZ0IsQ0FBQTtJQUNoQixvQ0FBbUIsQ0FBQTtJQUNuQiwrQkFBYyxDQUFBO0lBQ2QsOEJBQWEsQ0FBQTtJQUNiLGtDQUFpQixDQUFBO0lBQ2pCLDZDQUE0QixDQUFBO0lBQzVCLG1DQUFrQixDQUFBO0lBQ2xCLDhCQUFhLENBQUE7QUFDakIsQ0FBQyxFQWJXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBYXhCO0FBRVksUUFBQSxZQUFZLEdBQUc7SUFDMUIsYUFBYSxDQUFDLFFBQVE7SUFDdEIsYUFBYSxDQUFDLE9BQU87SUFDckIsYUFBYSxDQUFDLE9BQU87SUFDckIsYUFBYSxDQUFDLEtBQUs7SUFDbkIsYUFBYSxDQUFDLFNBQVM7SUFDdkIsYUFBYSxDQUFDLGlCQUFpQjtJQUMvQixhQUFhLENBQUMsU0FBUztDQUN4QixDQUFDIn0=